__turbopack_context__.v({
  "actionRow": "index-module-scss-module__i9qUvG__actionRow",
  "ant-dropdown-menu": "index-module-scss-module__i9qUvG__ant-dropdown-menu",
  "ant-dropdown-menu-item": "index-module-scss-module__i9qUvG__ant-dropdown-menu-item",
  "ant-dropdown-menu-item-selected": "index-module-scss-module__i9qUvG__ant-dropdown-menu-item-selected",
  "ant-dropdown-menu-title-content": "index-module-scss-module__i9qUvG__ant-dropdown-menu-title-content",
  "back-top-wrap": "index-module-scss-module__i9qUvG__back-top-wrap",
  "collapsed": "index-module-scss-module__i9qUvG__collapsed",
  "desc": "index-module-scss-module__i9qUvG__desc",
  "expanded": "index-module-scss-module__i9qUvG__expanded",
  "filterTableSelect": "index-module-scss-module__i9qUvG__filterTableSelect",
  "more": "index-module-scss-module__i9qUvG__more",
  "us": "index-module-scss-module__i9qUvG__us",
});
